/**
 * O endereco do arquivo de um documento (`/v1/publico/regulamentos/3/geral`, o que o backend devolve) vira o da pagina
 * de leitura (`/regulamento?versao=3&documento=geral`). Endereco que nao e desse formato segue como veio.
 */
export function paginaDoRegulamento(url: string): string {
  const m = /\/v1\/publico\/regulamentos\/(\d+)\/([^/?#]+)$/.exec(url);
  return m ? `/regulamento?versao=${m[1]}&documento=${m[2]}` : url;
}
